import { H1, H4, H7 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIViewController from 'UIComponents/input/UIViewController';
import ContentOverview from '../../../components/MostPopularCertificates/ContentOverview';
import { ModalTile, ModalTileSection } from '../../../components/TrackLessonOverviewModal/subcomponents/ModalTile';
//@ts-expect-error Could not find declaration file for module
import useMediaQuery from '../../../hooks/useMediaQuery';
import { device } from '../../../constants/StyledComponentConstants';
import styled from 'academy-common-lib/utils/Styling';
import { EnrollLessonButton, EnrollShortButton, EnrollTrackButton } from '../../userProgress';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LanguagesAvailableHeading = styled(H7).withConfig({
  displayName: "OverviewModalDescriptionSection__LanguagesAvailableHeading",
  componentId: "t21pmn-0"
})(["font-weight:500;"]);
const MobileHeading = styled(H4).withConfig({
  displayName: "OverviewModalDescriptionSection__MobileHeading",
  componentId: "t21pmn-1"
})(["font-weight:400;"]);
export const OverviewModalDescriptionSection = ({
  title,
  description,
  duration,
  selectedLanguage,
  availableLanguages,
  availableLanguagesLoading,
  onChangeSelectedLanguage,
  contentList,
  hasCertificate,
  hasStudyGuide,
  type,
  id,
  onEnroll
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const TitleComponent = isMobile ? MobileHeading : H1;
  return /*#__PURE__*/_jsxs(ModalTile, {
    children: [/*#__PURE__*/_jsxs(ModalTileSection, {
      children: [/*#__PURE__*/_jsx(TitleComponent, {
        children: title
      }), type === 'SHORT_FORM_CONTENT' ? /*#__PURE__*/_jsx(EnrollShortButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll
      }) : type === 'TRACK' ? /*#__PURE__*/_jsx(EnrollTrackButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll
      }) : /*#__PURE__*/_jsx(EnrollLessonButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll
      })]
    }), /*#__PURE__*/_jsxs(ModalTileSection, {
      className: "p-bottom-6",
      children: [/*#__PURE__*/_jsx(H7, {
        className: "p-bottom-2",
        children: duration
      }), description]
    }), /*#__PURE__*/_jsx(ModalTileSection, {
      className: "p-bottom-4",
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(LanguagesAvailableHeading, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.overviewModal.languagesAvailable"
          })
        }), availableLanguagesLoading || !availableLanguages ? /*#__PURE__*/_jsx(UILoadingSpinner, {}) : /*#__PURE__*/_jsx(UIViewController, {
          "data-test-id": "language-view-controller",
          defaultValue: selectedLanguage,
          onChange: onChangeSelectedLanguage,
          options: availableLanguages.map(lang => ({
            text: lang.toUpperCase(),
            value: lang
          })),
          size: "xs"
        })]
      })
    }), /*#__PURE__*/_jsxs(ModalTileSection, {
      children: [/*#__PURE__*/_jsx(H7, {
        className: "m-bottom-1 m-top-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.mostPopularCertificates.includes"
        })
      }), /*#__PURE__*/_jsx(ContentOverview, {
        content: contentList,
        hasCertificate: hasCertificate,
        hasStudyGuide: hasStudyGuide
      })]
    })]
  });
};
export default OverviewModalDescriptionSection;